import styled from 'styled-components'
import { FONT_SIZE, NATIVE_BASE_COLORS } from '../../../../themes'

const topBarHeight = 66
const pinCodeHeight = 52
const bottomBar = 84
const imageHeight = 300
const paddingTop = 4
const contentPadding = 32

export const FacilityManagementStyle = styled.div`
  padding: ${paddingTop}px 0 32px 0;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 0px;
  }

  .facility-management__image {
    width: 100%;
    display: flex;
    justify-content: center;
    
    img {
      width: 100%;
      height: ${imageHeight}px;
      object-fit: cover;
      text-align: center;
    }
  }

  .facility-management__room-name {
    padding: 0 0 8px 0;
    margin: 0;
    font-family: LibreBaskervilleBold;
    font-size: ${FONT_SIZE.LG2};
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
  }

  .facility-management__subtitle {
    margin: 0;
    padding: 0;
  }

  .facility-management__information {
    margin: 16px 0 24px 0;
    padding: 0;
  }

  .facility-management__content {
    height: ${({ isImage }) => 
      isImage 
        ? `calc(100vh - ${paddingTop + imageHeight + pinCodeHeight + topBarHeight + bottomBar + (1.5 * contentPadding)}px)` 
        : 'fit-content'};
    padding: 32px 0 0 0;
  }

  .facility-management__text-box {
    padding: 0 32px;
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
  }

  .facility-management__subtitle {
    color: ${NATIVE_BASE_COLORS.TEXT[500]};
    font-size: ${FONT_SIZE.TN};
    font-family: NunitoRegular;
  }

  .facility-management__divider {
    height: 1px;
    width: 100%;
    background-color: ${NATIVE_BASE_COLORS.MUTED[200]};
  }

  .facility-management__facility {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px 32px;
  }

  .facility-management__title {
    font-size: ${FONT_SIZE.SM};
    font-family: NunitoSansBold;
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    padding: 0;
    margin: 0;
  }

  .facility-management__list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .facility-management__item {
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    font-size: ${FONT_SIZE.TN};
    font-family: NunitoRegular;
    padding: 0;
    margin: 0;
  }

  .table-facilities {
    border-collapse: separate; 
    border-spacing: 0;
    width: 50%;
    border: 1px solid black;
    border-radius: 4px;
  }

  .th-facilities, .td-facilities {
    padding: 8px;
    border-bottom: 1px solid black;
  }

  .table-facilities tr:last-child td {
    border-bottom: none; /* Removes the border from the last row */
  }
  
  .td-facilities {
    color: ${NATIVE_BASE_COLORS.TEXT[900]};
    font-size: ${FONT_SIZE.TN};
    font-family: NunitoRegular;
  }

  .item-facilities {
    width: 100%;
  }

  .wrap {
    max-width: 50ch;
    white-space: normal;
    overflow-wrap: anywhere; 
    border-right: 1px solid black;
  }

  .size-70 {
    width: 70%;
    border-right: 1px solid black;
  }

  .size-30 {
    width: 30%;
  }

  .text-center {
    text-align: center;
  }

  .ACTIVE {
    color: green;
  }

  .INACTIVE {
    color: red;
  }

  .CLOSED {
    color: gray;
  }
`
